<template>
    <xl-dialog 
        :title="$t('design.case.patientOrder') || '患者订单'"
        width="1000px"
        v-model="visible"
        destroy-on-close
        :close-on-click-modal="false"
        :close-on-press-escape="false"
		:align-center="true"
		modal-class="add-case-dialog"
    >
        <div class="xl-cases-search flex space-between">
            <div class="xl-cases-search-wrapper" ref="searchRef">
                <xl-input
                    class="width148" v-model="searchObj.patientName" :placeholder="$t('design.case.patientName') || '患者姓名'" size="large"  @keydown.enter="search">
                    <template #suffix>
                        <i class="iconfont icon-sousuo" @click="search()"></i>
                    </template>
                </xl-input>
                <xl-input
                    class="width148" v-model="searchObj.doctorName" :placeholder="$t('design.case.doctorName') || '医生姓名'" size="large"  @keydown.enter="search">
                    <template #suffix>
                        <i class="iconfont icon-sousuo" @click="search()"></i>
                    </template>
                </xl-input>
                <xl-select class="width160" v-model="searchObj.designType" size="large" :placeholder="$t('design.case.allTheOrderType') || '全部病例类型'" clearable :options="designTypeList" @change="search()"></xl-select>
                <xl-date-picker
                    class="width240"
                    size="large"
                    type="daterange"
                    v-model="searchObj.time"
                    :start-placeholder="$t('design.uploadTime')"
                    :end-placeholder="$t('design.uploadTime')"
                    format="YYYY/MM/DD"
                    value-format="YYYY-MM-DD"
                    @change="search()"
                    unlink-panels
                    :shortcuts="datePickerShortCuts">
                </xl-date-picker>
                <!-- <xl-input
                    class="width160" v-if="factoryType==='hospital'" v-model="searchObj.labName" :placeholder="factoryType==='hospital'?$t('yunshuyouhua.labName'):$t( 'connections.search.hospital.label' )" size="large"  @keydown.enter="search">
                    <template #suffix>
                        <i class="iconfont icon-sousuo" @click="search()"></i>
                    </template>
                </xl-input> -->
            </div>
            <div class="xl-cases-search-btns">
                <xl-button @click="loadTargetData()" size="large">
                    <xl-icon name="zhongzhishitu1" class="mr4"></xl-icon>{{$t('design.reset')}}
                </xl-button>
            </div>
        </div>
        <div class="table-outer" ref="addCaseTableRef">
            <xl-table 
				ref="tabRef"
				height="100%"
                :emptyText="$t('design.noData')"
                :data="caseList"
                :headers="headers"
				@sort-change="changeTableSort" >
                <xl-table-column :label="$t('design.operate') || '操作'" width="120">
                    <template #default="{ row }">
                        <xl-button type="primary" @click="onImport(row)">{{$t('design.import') || "导入"}}</xl-button>
                    </template>
                </xl-table-column>
            </xl-table>
        </div>
        <xl-pagination v-model:page="pageInfo.page" v-model:pageSize="pageInfo.pageSize" :total="pageInfo.total"
			@pageSizeChange="updateTableData" @pageChange="updateTableData">
		</xl-pagination>
    </xl-dialog>
</template>

<script setup>
import { XlDialog, XlDatePicker, XlPagination, XlTable, XlTableColumn, XlIcon, XlMessage, XlMessageBox, XlSelect, XlInput, XlButton, XlPopover, XlEmpty, XlLoading } from "@shining3d/ui-components";
import { ref, h, defineExpose, watch, defineEmits, nextTick, computed } from 'vue';
import { $getLocalStorage } from '@shining3d/common-module/utils/index.js';
import { $convertLocalDateToUTCDate, $convertUTCDateToLocalDate } from '../../../utils/common.js';

import tableAvatarVue from '../../../components/tableAvatar.vue';
import tableServiceVue from '../../../components/tableService.vue';
import { useLang } from "@shining3d/common-module/utils/lang.js";
import Api from '../../../api/case.js';
import { designTypeList } from '../const';
import _get from 'lodash/get';
const { $t } = useLang("@shining3d/xl-design-order");

const emits = defineEmits(['import']);

const visible = ref( false );
const searchObj = ref({
	pageSize: 20,
	page: 1,
	time: [], // use
	searchSelectVal: '1',
	searchInputVal: '',
	designType: '', // use
	patientName: '', // use
	doctorName: '', // use
	labName: '',
	createBy: '',
	orderID: '',
	hospital: '',
	origin: [ 'Aoralscan', 'DeskTopScan', 'Facecan' ],
	sn: ''
});
const pageInfo = ref({
    page: 1,
	pageSize: 20,
	pages: 0,
	total: 0
});
const headers = ref([
	// {
	// 	prop: 'id',
    //     label: '订单ID',
	// },
    // 创建时间
    {
        prop: 'createOn',
        label: $t( 'user.case.createOn' ),
        sortable: 'custom',
        // minWidth: '180'
    },
    // 患者姓名
    {
        prop: 'patientName',
        label: $t( 'user.case.patientName' ),
        // minWidth: '180',
        cellRenderer: ( row ) => h( tableAvatarVue, { row })
    },
    // 病例类型
    {
        prop: 'designType',
        label: $t( 'user.case.designType' ),
        // minWidth: '150',
        cellRenderer: ( row ) => h( tableServiceVue, { row })
    },
    {
        prop: 'doctor',
		label: $t( 'user.case.doctor' ),
		// minWidth: '150',
		cellRenderer: ( row ) => {
			let result = '';
			const array = ['doctor.nickName', 'content.doctorName', 'content.baseInfo.doctorName'];
			array.forEach(( v, i ) => {
				if ( _get( row, v )) {
					result += (( result ? '/' : '' ) + _get( row, v ));
				}
			});
			if ( !result ) {
				result = '--'; 
			}
			return h( 'span', {}, row?.doctor.nickName || '-' );
		}
    }
]);

const getDiff = ( val ) => 60 * 60 * 1000 * 24 * val;

// 快捷选项
const shortCuts = {
	monthrangeShortCuts: [
		{
			text: $t( 'labDashboard.datePicker.shortCuts.nearMonth1' ),
			value: 30
		},
		{
			text: $t( 'labDashboard.datePicker.shortCuts.nearMonth3' ),
			value: 90
		},
		{
			text: $t( 'labDashboard.datePicker.shortCuts.nearMonth6' ),
			value: 180
		}
	]
};

const datePickerShortCuts = computed(() => _get( shortCuts, `monthrangeShortCuts`, []).map(( val ) => ({
	...val,
	value: () => {
		const end = new Date();
		const start = new Date();
		start.setTime( start.getTime() - getDiff( val.value ));
		return [start, end];
	}
})));

const caseList = ref([]);

const getParms = () => {
	const curOrg = $getLocalStorage( 'currentOrganization' )?.id ?? '1';
	let searchObjTemp = {};
	searchObjTemp = {
		status: searchObj.value.status,
		page: searchObj.value.page,
		pageSize: searchObj.value.pageSize,
		designType: searchObj.value.designType,
		patientName: searchObj.value.patientName,
		doctorName: searchObj.value.doctorName,
		createBy: searchObj.value.createBy,
		orderID: searchObj.value.orderID,
		labName: searchObj.value.labName,
		sortType: searchObj.value.sortType,
		sortBy: searchObj.value.sortBy,
		hospital: searchObj.value.hospital,
		origin: searchObj.value.origin?.join( ',' ),
		sn: searchObj.value.sn || ''
	};
	// searchObjTemp[ queryTypeByObj[ searchObj.value.searchSelectVal ] ] = searchObj.value.searchInputVal;
	if ( searchObj.value.time && searchObj.value.time.length === 2 ) {
		searchObjTemp.startOn = $convertLocalDateToUTCDate( searchObj.value.time[ 0 ]);
		searchObjTemp.endOn = $convertLocalDateToUTCDate( searchObj.value.time[ 1 ]);
	}
	const params = { ...searchObjTemp };
	if ( curOrg !== 'all' ) {
		params.orgID = curOrg;
	}
	return params;
};

const sortBy = ref( '' );
const sortType = ref( '' );
const changeTableSort = ( column ) => {
	if ( column.prop === 'createOn' ) {
		sortBy.value = 'create_on';
	} else {
		sortBy.value = '';
	}
	if ( column.order === 'ascending' ) {
		sortType.value = 'asc';
	} else if ( column.order === 'descending' ){
		sortType.value = 'desc';
	} else {
		sortType.value = '';
	}
	searchObj.value.sortType = sortType.value;
	searchObj.value.sortBy = sortBy.value;
	search();
};

const tabRef = ref(null);
const addCaseTableRef = ref(null);
const loadingInstance = ref(null);
const search = ( page = 1 ) => {
	searchObj.value.page = page;
	const params = getParms();
	if ( loadingInstance.value ) {
		loadingInstance.value?.close();
	}
	loadingInstance.value = XlLoading.service({
		target: addCaseTableRef.value,
		background: 'rgba(255,255,255,0.9)',
	});
	Api.getDentalList( params ).then( res => {
		loadingInstance.value?.close();
		if ( res && res.status === 'success' ) {
			if ( Array.isArray( res.result ) && res.result.length ) {
				res.result.forEach(( v ) => {
					v.createOn = $convertUTCDateToLocalDate( v.createOn );
					v.changeOn = $convertUTCDateToLocalDate( v.changeOn );
				});
				caseList.value = res.result;
				pageInfo.value = res.pageInfo;
			} else {
				caseList.value = [];
			}
			pageInfo.value = res.pageInfo || 0;
			tabRef.value?.xlTableRef?.setScrollTop( 0 );
		}
	}).catch(() => {
		loadingInstance.value?.close();
	});
};

const resetSObj = () => {
	searchObj.value = {
		pageSize: 20,
		page: 1,
		time: [],
		searchSelectVal: '1',
		searchInputVal: '',
		doctorName: '',
		origin: [ 'Aoralscan', 'DeskTopScan', 'Facecan' ],
		sn: ''
	};
};

const loadTargetData = () => {
	resetSObj();
	search();
};

const updateTableData = () => {
	searchObj.value.pageSize = pageInfo.value.pageSize;
	search( pageInfo.value.page );
};

const onImport = ( row ) => {
	// 导入
	visible.value = false;
	emits('import', row);
};

watch(() => visible.value, (val) => {
	if (val) {
		nextTick(() => {
			search();
		});
	}
});

const show = () => {
    visible.value = true;
};

defineExpose({ show });
</script>

<style lang="scss" scoped>
.loading-box{
  flex: 1;
  overflow: hidden;
}
.xl-pagination {
	padding: 12px;
	margin: 0 -12px;
	position: relative;
	&::before {
		content: '';
		width: 100%;
		position: absolute;
		top: 0;
		left: 0;
		border-top: 0.5px solid $color-n5;
	}
}
.width280 {
	width: 280px;
}
.width120 {
	width: 120px;
}
.width140 {
	width: 140px;
}
.width142 {
	width: 142px;
}
.width148 {
	width: 148px;
}
.width160 {
	width: 160px;
}
.width200 {
	width: 200px;
}
.width240{
	width: 240px;
}
.width256{
	width: 256px;
}
.width300{
	width: 300px;
}
.icon-sousuo{
	color: $color-n9;
	&:hover{
		cursor: pointer;
	}
}
.selected{
	color: rgba(85, 135, 255, 1) !important;
	border: 4px solid rgba(237, 243, 255, 1);
	border-radius: 6px;
	background-color: rgba(237, 243, 255, 1);
	position: relative;

}
.xl-cases-search {
	margin-top: 8px;
	margin-bottom: 16px;
	.height-auto {
		height: auto;
	}
	.h48 {
		height: 48px;
		overflow: hidden;
	}
	&-wrapper {
		display: flex;
		flex-wrap: wrap;
		& > :deep(div),
		& > :deep(i) {
			margin-right: 8px;
			margin-top: 8px;
		}
		&.height-auto {
			height: auto;
		}
		&.h48 {
			height: 48px;
			overflow: hidden;
		}
		:deep(.xl-date-picker.el-date-editor.el-range-editor.el-input__inner) {
			width: 240px;
		}
	}
	&-btns {
		flex: none;
		margin-top: 8px;
		display: flex;
	}
	.iconfont {
		line-height: 1;
	}
	.reset {
		// color: $color-n9;
		margin-right: 4px;
	}
	.btn-jiantou {
		margin-left: 4px;
		// font-size: 16px;
	}
	.mr4 {
		margin-right: 4px;
	}
	.ml4 {
		margin-left: 4px;
	}
	.hide-more {
		color: $color-b4;
	}
}
.xl-cases-search-top {
	height: 100%;
}
</style>
<style lang="scss">
.add-case-dialog {
	.el-overlay-dialog {
		display: flex;
		align-items: center;
		justify-content: center;
		overflow: hidden;
		.el-dialog {
			margin: 0px;
			height: 804px;
			max-height: calc(100vh - 96px);
			.el-dialog__body {
				padding: 8px 0 0 0;
				height: calc(100% - 8px - 68px);
				display: flex;
				flex-direction: column;
				cursor: auto;
				overflow: hidden;
			}
		}

		.table-outer {
			flex: 1;
			overflow: hidden;
		}
	}
}
</style>